import React, { useState, useEffect } from "react";
import * as Styled from "./styled";
import Sidemenu from "../../components/sidemenu";
import Header from "../../components/header";
import { functionService } from "../../lib/functions";
import { Select, DatePicker, Menu, Dropdown, Modal, Input, Button } from "antd";
import moment from "moment";
import dayjs from "dayjs";
import Report from "../companyTable/components/CompanyLogin";
import { useNavigate } from "react-router-dom";

import ProfileComp from "../profileView/ProfileComp";
import Assessment from "../profileView/Assessment";
import ProjectWork from "../profileView/ProjectWork";
import ScreeningInterview from "../profileView/ScreeningInterview";

const ProfileTable = () => {
  const [jobListings, setJobListings] = useState([]);
  const [recruiterOptions, setRecruiterOptions] = useState([]);
  const [selectedRecruiter, setSelectedRecruiter] = useState(null);
  const [companyList, setCompanyList] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedCallStatus, setSelectedCallStatus] = useState(null);
  const [selectedReviewStatus, setSelectedReviewStatus] = useState(null);
  const [selectedCompanyShortlistStatus, setSelectedCompanyShortlistStatus] =
    useState(null);
  const [selectedAssessmentStatus, setSelectedAssessmentStatus] =
    useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [filteredJobListings, setFilteredJobListings] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const navigate = useNavigate();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalData, setModalData] = useState({
    id: "",
    email: "",
    firstName: "",
    lastName: "",
  });
  const [currentSalary, setCurrentSalary] = useState("");
  const [perHourRate, setPerHourRate] = useState("");
  const [currency, setCurrency] = useState("");
  const [companyEmail, setCompanyEmail] = useState("");
  const [isViewModalVisible, setIsViewModalVisible] = useState(false); // State for View Modal

  const [data, setData] = useState("");
  const [loading, setLoading] = useState(false);
  const [element, setElement] = useState("");
  const [downloadHover, setDownloadHover] = useState(false);
  const [viewData, setViewData] = useState(null);
  const showModal = (candidateData) => {
    console.log("candidate data is-------->", candidateData.id);
    setModalData(candidateData);
    setIsModalVisible(true);
  };

  const handleOk = async () => {
    let newObject = {
      email_company: companyEmail,
      email_candidate: null,
      candidate_id: modalData.id,
      salary: currentSalary,
      hour_count: perHourRate,
      currency_type: currency,
      first_name: null,
      last_name: null,
      role: null,
      experience: null,
      available_from: null,
      cv_url:null
    };

    try {
      let res = await functionService.getCandidateInfo(modalData.id);
      let apiData = res?.response?.data?.data;
      let candidateDetails = apiData[0];
      console.log("Merry Christmans -------->",candidateDetails);
      newObject = {
        ...newObject,
        first_name: candidateDetails.first_name,
        last_name: candidateDetails.last_name,
        role: candidateDetails.current_role,
        email_candidate: candidateDetails.email,
        experience: candidateDetails.total_work_exp,
        available_from: candidateDetails.available_from,
        received_on:new Date(),
        cv_url:candidateDetails.cv_url
      };

      console.log("Updated object to pass to the API:", newObject);
      let resData = await functionService.insertCandidateInfo(newObject);
      let data = resData?.response?.data?.data;

      let statusResult = await functionService.sentStatusToCompany(
        modalData.id
      );
     
      let dataRes = await functionService.insertCompanyEmail({email:companyEmail});
      let dataResStatus = dataRes?.response?.data?.data;
      console.log("Data3------------------->",dataResStatus);

      let dataEmail = await functionService.sendMailToCompany({email:companyEmail,websiteLink:`${process.env.REACT_APP_COMPANY_API}company-login`});
      let emailData = dataEmail?.response?.data?.data;
      console.log("Data3------------------->",emailData);
    } catch (error) {
      console.error("Error fetching recruiters list:", error);
    }

    setIsModalVisible(false);
  };

 
  const handleCancel = () => {
    setIsModalVisible(false);
    setIsViewModalVisible(false); // Close View modal too
  };

  const getCompanyName = async () => {
    const response = await functionService.get("demand/demand-companies-list");
    if (response?.response?.data?.data?.length > 0) {
      setCompanyList(response.response.data.data);
    }
  };

  const recruiterSearch = async () => {
    try {
      let res = await functionService.get(`demand/recruiters-list`);
      let apiData = res?.response?.data?.data;

      const optionsWithNames = apiData.map((item) => ({
        ...item,
        recruiter_name: item.label,
      }));
      setRecruiterOptions(optionsWithNames);
    } catch (error) {
      console.error("Error fetching recruiters list:", error);
    }
  };

  const fetchProfileListings = async () => {
    try {
      const demandDetails = await functionService.getProfileListings();

      if (demandDetails.status) {
        const jsonData = demandDetails.response.data.data;
        setJobListings(jsonData);
      } else {
        console.error("Error fetching demand details:", demandDetails.error);
      }
    } catch (error) {
      console.error("Error in fetchDetails:", error);
    }
  };

  useEffect(() => {
    getCompanyName();
    recruiterSearch();
    fetchProfileListings();
  }, []);

  useEffect(() => {
    let filteredListings = jobListings;

    if (selectedCompany) {
      filteredListings = filteredListings.filter(
        (item) => item.company_name === selectedCompany
      );
    }

    if (selectedCallStatus) {
      filteredListings = filteredListings.filter((item) =>
        selectedCallStatus === "Connected"
          ? item.call_connected
          : !item.call_connected
      );
    }

    if (selectedReviewStatus) {
      filteredListings = filteredListings.filter(
        (item) =>
          item.review_status?.toLowerCase() ===
          selectedReviewStatus.toLowerCase()
      );
    }

    if (selectedCompanyShortlistStatus) {
      filteredListings = filteredListings.filter(
        (item) =>
          item.company_shortlist_status?.toLowerCase() ===
          selectedCompanyShortlistStatus.toLowerCase()
      );
    }

    if (selectedAssessmentStatus) {
      filteredListings = filteredListings.filter(
        (item) =>
          item.assessment_status?.toLowerCase() ===
          selectedAssessmentStatus.toLowerCase()
      );
    }

    if (selectedRecruiter) {
      filteredListings = filteredListings.filter(
        (item) => item.recruiter_name === selectedRecruiter
      );
    }

    if (selectedDate) {
      filteredListings = filteredListings.filter((item) =>
        moment(item.updated_at).isSame(selectedDate, "day")
      );
    }

    setFilteredJobListings(filteredListings);
  }, [
    selectedCompany,
    selectedCallStatus,
    selectedReviewStatus,
    selectedCompanyShortlistStatus,
    selectedAssessmentStatus,
    selectedDate,
    jobListings,
    selectedRecruiter,
  ]);

  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedListings = filteredJobListings.slice(
    startIndex,
    startIndex + itemsPerPage
  );
  const totalPages = Math.ceil(filteredJobListings.length / itemsPerPage);

  const requestData = async (id) => {
    let obj = {
      assessment_id: id,
    };
    try {
      let res = await functionService.getMockDetails(obj);
      console.log("res is ------->", res);
      let apiData = res?.response?.data?.formattedData[0];
      setData(apiData);
      console.log("Mock data is------->", apiData);
    } catch (error) {
      console.error("Error fetching recruiters list:", error);
    }
  };

  const menu = (id, fname, lname, email, assessment_id) => (
    <Menu
      onClick={({ key }) =>
        handleMenuClick(key, id, fname, lname, email, assessment_id)
      }
    >
      <Menu.Item key="0">Send profiles to company</Menu.Item>
      <Menu.Item key="1">Download Assessment Report</Menu.Item>
    </Menu>
  );

  const handleMenuClick = (key, id, fname, lname, email, assessment_id) => {
    switch (key) {
      case "0":
        showModal({ id, firstName: fname, lastName: lname, email });
        break;
      case "1":
        console.log("Assessment ID:", assessment_id);
        const download = async (assessment_id) => {
          const assessmentDetails = await requestData(assessment_id);
        };
         download(assessment_id);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (data) {
      let element =
        document && document.getElementById(`pdf-content-${data.id}`);
      setElement(element);
    }
  }, [data]);
  useEffect(() => {
    if (element) {
      func();
    }
  }, [element]);

  const func = async () => {
    if (element !== "") {
      const html2pdf = (
        await import("/node_modules/html2pdf.js/dist/html2pdf.min")
      ).default;
      let body = document.body;
      let html = document.documentElement;
      let height = Math.max(
        body.scrollHeight,
        body.offsetHeight,
        html.clientHeight,
        html.scrollHeight,
        html.offsetHeight
      );

      let heightCM = height / 5;
      let name = `${data?.name ? data?.name + "_" : ""}${
        data?.test_title
      } assessment report`?.replace(/\./g, "");
      var opt = {
        margin: [1, 0.5, 1.3, 0.5],
        filename: name,
        // image:        { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2, letterRendering: true },
        pagebreak: ["avoid-all", "css", "legacy"],
        // pagebreak: {mode: 'avoid-all'},

        jsPDF: {
          orientation: "portrait",
          unit: "cm",
          format: [heightCM, 23],
        },
      };

      try {
        html2pdf().set(opt).from(element).save();
        setElement("");
      } catch (e) {
        console.log(e);
      }
    }
  };


  //Dummy Data for profile
  const profile = {
    name: `${viewData?.first_name} ${viewData?.last_name}`,
    contact: viewData?.primary_no,
    email: viewData?.email,
    exp: `${viewData?.total_work_exp/12} years ${viewData?.total_work_exp%12} month`,
    salary: viewData?.current_ctc,
    score: 92,
    imageUrl:
      "https://media.istockphoto.com/id/513727339/photo/head-and-shoulders-mans-silhouette.jpg?s=612x612&w=0&k=20&c=aAVL1IT9GT4URtLjS98515G5e3Qc4c7Np2EvKXBywMQ=",
    cvUrl:viewData?.cv_url
  };

  // const assessments = [
  //   {
  //     title: "Back End Developer - Node.js",
  //     skill: "Node.js",
  //     duration: "1 Hr 30 Min",
  //     marks: "60",
  //     score: "45/60",
  //     videoSrc: "/path-to-nodejs-assessment-video.mp4",
  //     downloadLink: "#",
  //   },
  //   {
  //     title: "Front End Developer - React.js",
  //     skill: "React.js",
  //     duration: "1 Hr 30 Min",
  //     marks: "60",
  //     score: "48/60",
  //     videoSrc: "/path-to-reactjs-assessment-video.mp4",
  //   },
  // ];
  // const project = {
  //   title: "Design Calculator",
  //   skill: "React.js",
  //   duration: "1 Hr 30 Min",
  //   downloadLink: "#",
  // };
  // const interview = {
  //   title: "Node.js Screening Interview ",
  //   skill: "Node.js",
  //   duration: "1 Hr 30 Min",
  // };
  
  const handleIconClick = (data, viewItem) => {
    setModalData({
      status: data,
    });
    if (data === "View") {
      setViewData(viewItem); // Store the view data to be shown in modal
      setIsViewModalVisible(true); // Show View modal
    } else {
      setIsModalVisible(true); // Show Approval/Reject modal
    }
  };

  return (
    <Styled.MainDiv>
      <Sidemenu />
      <Header />
      <Styled.ContentWrapDiv>
      <Styled.TopContainer>
        <div className="leftSide">Candidate Profiles</div>
        <div className="rightSide">
        <button onClick={()=>{navigate('/submission-form')}}>New Call</button>
        </div>
        </Styled.TopContainer>
        <div style={{ display: "flex", gap: "20px", marginBottom: "20px" }}>
          <Select
            showSearch
            placeholder="Select a company"
            optionFilterProp="children"
            onChange={(value) => setSelectedCompany(value)}
            allowClear
            style={{ width: "200px" }}
          >
            {companyList.map((item) => (
              <Select.Option key={item.company_name} value={item.company_name}>
                {item.company_name}
              </Select.Option>
            ))}
          </Select>

          <Select
            placeholder="Call status"
            onChange={(value) => setSelectedCallStatus(value)}
            allowClear
            style={{ width: "150px" }}
          >
            <Select.Option value="Connected">Connected</Select.Option>
            <Select.Option value="Not Connected">Not Connected</Select.Option>
          </Select>

          <Select
            placeholder="Review status"
            onChange={(value) => setSelectedReviewStatus(value)}
            allowClear
            style={{ width: "150px" }}
          >
            <Select.Option value="Pending">Pending</Select.Option>
            <Select.Option value="Approved">Approved</Select.Option>
          </Select>

          <Select
            placeholder="Company shortlist status"
            onChange={(value) => setSelectedCompanyShortlistStatus(value)}
            allowClear
            style={{ width: "200px" }}
          >
            <Select.Option value="Pending">Pending</Select.Option>
            <Select.Option value="Approved">Approved</Select.Option>
          </Select>

          <Select
            placeholder="Assessment status"
            onChange={(value) => setSelectedAssessmentStatus(value)}
            allowClear
            style={{ width: "200px" }}
          >
            <Select.Option value="Attempted">Attempted</Select.Option>
            <Select.Option value="Not Attempted">Not Attempted</Select.Option>
            <Select.Option value="Submitted">Submitted</Select.Option>
          </Select>

          <Select
            showSearch
            placeholder="Select a recruiter"
            optionFilterProp="children"
            onChange={(value) => setSelectedRecruiter(value)}
            allowClear
            style={{ width: "200px" }}
          >
            {recruiterOptions.map((item) => (
              <Select.Option
                key={item.recruiter_name}
                value={item.recruiter_name}
              >
                {item.recruiter_name}
              </Select.Option>
            ))}
          </Select>

          <DatePicker
            placeholder="Select date"
            onChange={(date) =>
              setSelectedDate(date ? date.format("YYYY-MM-DD") : null)
            }
            style={{ width: "200px" }}
          />
        </div>

        <Styled.TableWrap>
          <Styled.MainTable>
            <thead>
              <tr>
                <th>Candidate details</th>
                <th>First sourcing date</th>
                <th>Last updated on</th>
                <th>Account name</th>
                <th>Role</th>
                <th>Current CTC</th>
                <th>Expected CTC</th>
                <th>Offer In Hand</th>
                <th>Offered CTC</th>
                <th>Notice Period</th>
                <th>Recruiter</th>
                <th>Review status</th>
                <th>Assessment Schedule</th>
                <th>Assessment status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {paginatedListings.map((item, index) => (
                <tr key={index}>
                  <td>
                    {item.first_name} {item.last_name} <br />
                    {item.email} <br />
                    {item.primary_no}
                  </td>
                  <td>{new Date(item.created_at).toLocaleDateString()}</td>
                  <td>{new Date(item.updated_at).toLocaleDateString()}</td>
                  <td>{item.company_name}</td>
                  <td>{item.role_title}</td>
                  <td>{item.current_ctc} LPA</td>
                  <td>{item.expected_ctc} LPA</td>
                  <td>{item.offer_in_hand ? "Yes" : "-"}</td>
                  <td>{item.offer_in_hand ? item.offered_ctc + " LPA" : "-"}</td>
                  <td>{item.notice_period} Days</td>
                  <td>{item.recruiter_name}</td>
                  <td>{item.review_status.charAt(0).toUpperCase() + item.review_status.slice(1)}</td>
                  <td>
                    {item.assessment_schedule_datetime
                      ? dayjs(item.assessment_schedule_datetime).format("DD-MM-YYYY HH:mm")
                      : "Not scheduled"}
                  </td>
                  <td>{item.assessment_status ? "Attempted" : "Not Attempted"}</td>
                  <td>
                    <Styled.IconDiv>
                      <Styled.ViewButton onClick={() => { handleIconClick("View", item); }} />
                      <Styled.UpdateButton />
                      <Dropdown
                        trigger={["click"]}
                        overlay={menu(
                          item.id,
                          item.first_name,
                          item.last_name,
                          item.email,
                          item.assessment_id
                        )}
                      >
                        <Styled.OptionButton />
                      </Dropdown>
                    </Styled.IconDiv>
                  </td>
                </tr>
              ))}
            </tbody>
          </Styled.MainTable>
        </Styled.TableWrap>

        <Styled.ParentContainer>
          <Styled.PaginationDiv>
            <button
              onClick={() => setCurrentPage(currentPage - 1)}
              disabled={currentPage === 1}
              style={{ minWidth: "75px" }}
            >
              Previous
            </button>

            {currentPage > 3 && (
              <>
                <button onClick={() => setCurrentPage(1)}>1</button>
                <div className="ellipsis">...</div>
              </>
            )}

            {[...Array(totalPages)].map((_, i) => {
              const pageNumber = i + 1;

              if (
                pageNumber === currentPage ||
                (pageNumber >= currentPage - 1 && pageNumber <= currentPage + 1)
              ) {
                console.log("active page ========>", pageNumber, currentPage);
                return (
                  <Styled.PaginationButton
                    key={i}
                    onClick={() => setCurrentPage(pageNumber)}
                    active={pageNumber == currentPage}
                  >
                    {pageNumber}
                  </Styled.PaginationButton>
                );
              }
              return null;
            })}

            {currentPage < totalPages - 2 && (
              <>
                <div className="ellipsis">...</div>
                <button onClick={() => setCurrentPage(totalPages)}>
                  {totalPages}
                </button>
              </>
            )}

            <button
              onClick={() => setCurrentPage(currentPage + 1)}
              disabled={currentPage === totalPages}
              style={{ minWidth: "75px" }}
            >
              Next
            </button>
          </Styled.PaginationDiv>
        </Styled.ParentContainer>

        <Modal
           visible={isViewModalVisible}
           onCancel={handleCancel}
           footer={[
             <Button key="back" onClick={handleCancel}>
               Close
             </Button>,
          ]}
        >
          <div>
            <ProfileComp profile={profile} />
            {/* <Styled.Heading>Assesment History-Live Recordings </Styled.Heading>
            <Styled.HeadingDescription>
              You will be able to view the complete recording of the candidate’s
              assessments. This way you can also check his approach to problem
              solving and not just depend on the final output.
            </Styled.HeadingDescription>
            {assessments.map((assessment, index) => (
              <Assessment key={index} assessments={assessment} />
            ))}
            <Styled.Heading>Project Work </Styled.Heading>
            <Styled.HeadingDescription>
              This section has the complete recording of candidate’s approach to
              the project work.
            </Styled.HeadingDescription>
            <ProjectWork project={project} />
            <Styled.Heading>Screening Interview </Styled.Heading>
            <Styled.HeadingDescription>
              Here you can see how the candidate answers some real interview
              questions. It will give you an insight into his communication
              skills, his ability to handle pressure and details of his past
              experiences. Makes the hiring decision real easy.{" "}
            </Styled.HeadingDescription>
            <ScreeningInterview interview={interview} /> */}
          </div>
        </Modal>




        <Modal
          title="Send Profiles"
          visible={isModalVisible}
          onCancel={handleCancel}
          style={{ width: "750px" }}
          footer={[
            <Button key="back" onClick={handleCancel}>
              Cancel
            </Button>,
            <Button key="submit" type="primary" onClick={handleOk}>
              Send Profiles
            </Button>,
          ]}
        >
          <Styled.FormDiv>
            <span>Email Address</span>
            <Input
              placeholder="Enter your email address"
              onChange={(e) => setCompanyEmail(e.target.value)}
            />
            <div>
              Enter the salary of the candidates before sharing there profile
              with the comapany
            </div>
            <span>
              {modalData.firstName} {modalData.lastName}({modalData.email})
            </span>
            <div style={{ display: "flex", flexDirection: "row", gap: "25px" }}>
              <Select
                placeholder="Select currency"
                style={{ width: "210px", marginBottom: "20px" }}
                onChange={(value) => setCurrency(value)}
              >
                <Select.Option value="USD">USD</Select.Option>
                <Select.Option value="INR">INR</Select.Option>
              </Select>
              <Input
                placeholder="Enter Salary"
                style={{ height: "32px" }}
                //value={perHourRate}
                onChange={(e) => setCurrentSalary(e.target.value)}
              />
              <Select
                placeholder="Per hour"
                style={{ width: "100%", marginBottom: "20px" }}
                onChange={(value) => setPerHourRate(value)}
              >
                <Select.Option value="1">1</Select.Option>
                <Select.Option value="2">2</Select.Option>
                <Select.Option value="3">3</Select.Option>
                <Select.Option value="4">4</Select.Option>
              </Select>
            </div>
          </Styled.FormDiv>
        </Modal>
      </Styled.ContentWrapDiv>
      <Report data={data}/>
    </Styled.MainDiv>
  );
};

export default ProfileTable;
